import { type Listing } from '@/features/listing/types/listing-types';
import { type Conversation } from '@/features/messages/types/conversation-types';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { type User } from '@/features/user/types/user-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';
import { type MessageSentSource } from '@/shared/types/report-types';

interface CreateListingMessageData {
  listingId?: Listing['id'],
  message: string,
  recipientId?: User['id'],
  conversationId?: Conversation['conversationID'],
  messageSrc?: MessageSentSource,
  attachments?: null,
}

// TODO: move to share folder
export default async function createMessage({
  conversationId,
  listingId,
  message,
  messageSrc,
  recipientId,
}: CreateListingMessageData) {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/messages`;
  const bearerToken = getUserBearerCookie();

  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  const messageData: Record<string, string | number | boolean | null> = {
    message_text: message,
    pushtosocket: false,
    ...(messageSrc && { src: messageSrc }),
    ...(recipientId && { recipient_user_id: recipientId }),
    ...(conversationId && { conversation: conversationId }),
    ...(messageSrc === 'mailbox' && { attachments: null }),
  };

  if (listingId) {
    // eslint-disable-next-line canonical/id-match
    messageData.listing_id = listingId;
  }

  const createListingBookmarksResponse = await fetch(url, {
    body: JSON.stringify(messageData),
    cache: 'no-store',
    headers,
    method: 'POST',
  });

  if (!createListingBookmarksResponse.ok) {
    sendHttpError({
      baseName: `Send message ${messageSrc ?? ''}`,
      body: messageData,
      functionName: 'createMessage',
      method: 'POST',
      requestHeaders: headers,
      statusCode: createListingBookmarksResponse.status,
      url,
    });

    throw new Error('Failed to fetch data');
  }
}
